export default "__VITE_ASSET__D5XpD27m__"